import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';

import CostList from './CostList';
import CostCreate from './CostCreate';
import CostShow from './CostShow';
import CostEdit from './CostEdit';

const costs = {
	list: CostList,
	create: CostCreate,
	show: CostShow,
	edit: CostEdit,
	icon: EuroSymbolIcon
};

export default costs;
